<template>
  <div class="app-container dashboard-hot-hotel">
    <!-- 筛选栏 -->
    <div class="filter-container">
      <el-form :inline="true" size="small">
        <el-form-item label="下游客户">
          <el-select
            v-model="hotelFilter.client"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="输入搜索客户"
            :remote-method="searchClient"
            :loading="clientLoading"
            style="width: 200px"
          >
            <el-option
              v-for="c in clientOpts"
              :key="c"
              :label="c"
              :value="c"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-model="hotelFilter.dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="城市">
          <el-input
            v-model="hotelFilter.city"
            clearable
            placeholder="输入城市"
            style="width: 130px"
          ></el-input>
        </el-form-item>
        <el-form-item label="酒店品牌">
          <el-input
            v-model="hotelFilter.brand"
            clearable
            placeholder="输入品牌"
            style="width: 130px"
          ></el-input>
        </el-form-item>
        <el-form-item label="上游渠道">
          <el-select
            v-model="hotelFilter.channel"
            placeholder="全部渠道"
            style="width: 130px"
            clearable
            filterable
          >
            <el-option label="全部渠道" value="" />
            <el-option
              v-for="channel in channelList"
              :key="channel.value"
              :label="channel.label"
              :value="channel.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="filterHotels">查询</el-button>
          <el-button @click="resetHotelFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 热销概览 -->
    <el-card shadow="never" class="mb18">
      <div class="bottom-strip">
        <div class="bk-item">
          <div class="bk-label">上榜酒店</div>
          <div class="bk-val" style="color: #409eff">
            {{ hotels.length }} 家
          </div>
          <div class="bk-sub">覆盖 {{ cityOpts.length }} 个城市</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">总销量(间夜)</div>
          <div class="bk-val" style="color: #303033">
            {{ totalNights }} 间夜
          </div>
          <div class="bk-sub">本期累计</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">总营业额</div>
          <div class="bk-val" style="color: #303033">¥{{ totalRev }}</div>
          <div class="bk-sub">含税含佣</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">平均房价 ADR</div>
          <div class="bk-val" style="color: #303033">¥{{ avgAdr }}</div>
          <div class="bk-sub">加权均值</div>
        </div>
        <div class="bk-item">
          <div class="bk-label">覆盖下游客户</div>
          <div class="bk-val" style="color: #303033">{{ totalClients }} 家</div>
          <div class="bk-sub">分销渠道数</div>
        </div>
      </div>
    </el-card>

    <!-- 热销酒店排行 -->
    <el-card shadow="never">
      <div class="cust-toolbar">
        <div class="cust-left">
          <span style="font-size: 14px; font-weight: 600; color: #303133"
            >热销酒店排行</span
          >
          <span class="cust-count"
            >按销量(间夜)排序 · 共 <b>{{ hotelRows.length }}</b> 家</span
          >
        </div>
        <div class="cust-right">
          <el-input
            v-model="hotelSearch"
            placeholder="搜索酒店名称"
            size="small"
            style="width: 180px"
            clearable
            @input="searchInResults"
            @keyup.enter.native="searchInResults"
          ></el-input>
        </div>
      </div>
      <el-table
        :data="paginatedHotels"
        border
        size="small"
        :header-cell-style="{
          background: '#fafafa',
          color: '#909399',
          fontWeight: 500,
        }"
        style="width: 100%"
        @sort-change="handleSortChange"
      >
        <el-table-column label="排名" width="70" align="center">
          <template slot-scope="scope">
            <span
              v-if="getRank(scope.$index) <= 3"
              :class="'rank-medal rank-' + getRank(scope.$index)"
              >{{ getRank(scope.$index) }}</span
            >
            <span v-else class="rank-num">{{ getRank(scope.$index) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="酒店名称"
          min-width="180"
        ></el-table-column>
        <el-table-column label="品牌集团" width="120">
          <template slot-scope="scope">
            <span :class="'brand-tag ' + getBrandClass(scope.row.brand)">{{
              scope.row.brand
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上游渠道" width="100">
          <template slot-scope="scope">
            <span
              :class="'channel-tag ' + getChannelClass(scope.row.channel)"
              >{{ scope.row.channel }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="城市" width="90">
          <template slot-scope="scope">
            <span class="city-tag">{{ scope.row.city }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nights" label="销量(间夜)" width="110" sortable>
          <template slot-scope="scope"
            ><b>{{ formatNumber(scope.row.nights) }}</b></template
          >
        </el-table-column>
        <el-table-column prop="revenue" label="营业额" width="130" sortable>
          <template slot-scope="scope"
            >¥{{ formatNumber(scope.row.revenue) }}</template
          >
        </el-table-column>
        <el-table-column
          prop="orders"
          label="订单数"
          width="90"
          sortable
        ></el-table-column>
        <el-table-column prop="adr" label="客单价" width="90" sortable>
          <template slot-scope="scope">¥{{ scope.row.adr }}</template>
        </el-table-column>
        <el-table-column prop="mom" label="环比" width="90" sortable>
          <template slot-scope="scope">
            <span
              :class="scope.row.mom >= 0 ? 'hero-rate up' : 'hero-rate down'"
              style="font-size: 13px; font-weight: 600"
            >
              {{ scope.row.mom >= 0 ? '↑' : '↓' }}{{ Math.abs(scope.row.mom) }}%
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="clients"
          label="覆盖客户"
          width="90"
          sortable
        ></el-table-column>
      </el-table>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 14px;
        "
      >
        <span style="font-size: 12px; color: #909399"
          >共 {{ hotelRows.length }} 条 &nbsp; {{ pageSize }}条/页</span
        >
        <el-pagination
          layout="prev, pager, next, jumper"
          :total="hotelRows.length"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          small
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import { fetchTargetTypes } from '@/utils/targetType'

export default {
  name: 'DashboardHotHotel',
  data() {
    return {
      hotels: [],
      hotelRows: [],
      hotelFilter: {
        client: '',
        dateRange: null,
        city: '',
        brand: '',
        channel: '',
      },
      hotelSearch: '',
      clientLoading: false,
      clientOpts: [],
      clientMaster: [],
      channelList: [],
      currentPage: 1,
      pageSize: 10,
      sortField: 'nights',
      sortOrder: 'descending',
    }
  },
  computed: {
    totalNights() {
      return this.formatNumber(this.hotelRows.reduce((a, b) => a + b.nights, 0))
    },
    totalRev() {
      return this.formatNumber(
        this.hotelRows.reduce((a, b) => a + b.revenue, 0),
      )
    },
    avgAdr() {
      const n = this.hotelRows.reduce((a, b) => a + b.nights, 0)
      const r = this.hotelRows.reduce((a, b) => a + b.revenue, 0)
      return n ? Math.round(r / n) : 0
    },
    // 从 hotels 派生唯一城市列表
    cityOpts() {
      return [...new Set(this.hotelRows.map((h) => h.city).filter(Boolean))]
    },
    // 覆盖下游客户 = 从所有酒店的 custs 字段合并后的唯一值
    totalClients() {
      const allCusts = this.hotelRows.flatMap((h) => h.custs || [])
      return new Set(allCusts).size
    },
    paginatedHotels() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.hotelRows.slice(start, end)
    },
  },
  created() {
    this.fetchClients()
    this.getChannelList()
    this.fetchHotels()
  },
  methods: {
    getChannelList() {
      fetchTargetTypes().then((types) => {
        this.channelList = (types || []).map((item) => ({
          label: item.label || item.name || item.value,
          value: item.value || item.id || item.label,
        }))
      })
    },

    fetchClients() {
      request({
        url: '/api/backend/dataCount/appClientList',
        method: 'get',
        params: { limit: 500 },
      }).then((response) => {
        const payload = response.data || {}
        const list = Array.isArray(payload) ? payload : payload.data || []
        this.clientMaster = list.map((c) => c.name).filter(Boolean)
        this.clientOpts = this.clientMaster
      })
    },

    fetchHotels() {
      // 构建查询参数
      const params = {}
      if (
        this.hotelFilter.dateRange &&
        this.hotelFilter.dateRange.length === 2
      ) {
        params.start_at = this.hotelFilter.dateRange[0]
        params.end_at = this.hotelFilter.dateRange[1]
      }
      if (this.hotelFilter.city) {
        params.city = this.hotelFilter.city
      }
      if (this.hotelFilter.brand) {
        params.brand = this.hotelFilter.brand
      }
      if (this.hotelFilter.channel) {
        params.channel = this.hotelFilter.channel
      }
      if (this.sortField) {
        params.sort = this.sortField
      }

      request({
        url: '/api/backend/dataCount/hotelList',
        method: 'get',
        params,
      })
        .then((response) => {
          const payload = response.data || []
          const list = Array.isArray(payload) ? payload : payload.data || []
          this.hotels = list.map(this.normalizeHotel)
          this.applyFiltersAndSort()
        })
        .catch(() => {
          this.hotels = []
          this.hotelRows = []
          this.$message.error('获取热销酒店数据失败')
        })
    },

    filterHotels() {
      this.currentPage = 1
      this.fetchHotels()
    },

    // 前端搜索过滤（在已有数据中搜索酒店名称）
    searchInResults() {
      this.currentPage = 1
      this.applyFiltersAndSort()
    },

    normalizeHotel(hotel) {
      const nights = parseInt(hotel.nights || 0, 10)
      const revenue = parseFloat(hotel.revenue) || 0
      const orders = parseInt(hotel.orders || 0, 10)
      const adr =
        parseFloat(hotel.adr) || (nights ? Math.round(revenue / nights) : 0)
      const mom = parseFloat(hotel.mom) || 0
      const custs = Array.isArray(hotel.custs) ? hotel.custs : []
      const clients = parseInt(hotel.clients || 0, 10) || custs.length

      return {
        ...hotel,
        name: hotel.name || '-',
        brand: hotel.brand || '-',
        channel: hotel.channel || '-',
        city: hotel.city || '-',
        nights,
        revenue,
        orders,
        adr,
        mom,
        clients,
        custs,
      }
    },

    applyFiltersAndSort() {
      const keyword = this.hotelSearch.trim().toLowerCase()
      const client = this.hotelFilter.client
      let rows = [...this.hotels]

      if (client) {
        rows = rows.filter((hotel) => hotel.custs.includes(client))
      }
      if (keyword) {
        rows = rows.filter((hotel) =>
          String(hotel.name || '')
            .toLowerCase()
            .includes(keyword),
        )
      }

      this.hotelRows = this.sortHotels(rows)
      this.ensureValidPage()
    },

    // 排序处理
    handleSortChange({ prop, order }) {
      if (!prop) return
      this.sortField = prop
      this.sortOrder = order || 'descending'
      this.currentPage = 1
      this.applyFiltersAndSort()
    },

    sortHotels(rows) {
      const field = this.sortField || 'nights'
      const direction = this.sortOrder === 'ascending' ? 1 : -1
      return [...rows].sort((a, b) => {
        const valA = parseFloat(a[field]) || 0
        const valB = parseFloat(b[field]) || 0
        return (valA - valB) * direction
      })
    },

    ensureValidPage() {
      const maxPage = Math.max(
        1,
        Math.ceil(this.hotelRows.length / this.pageSize),
      )
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage
      }
    },

    resetHotelFilter() {
      this.hotelFilter = {
        client: '',
        dateRange: null,
        city: '',
        brand: '',
        channel: '',
      }
      this.hotelSearch = ''
      this.currentPage = 1
      // 重新获取数据（不带筛选参数）
      this.fetchHotels()
    },

    getRank(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },

    getBrandClass(brand) {
      if (String(brand || '').indexOf('亚朵') >= 0) return 'brand-yd'
      return 'brand-default'
    },

    getChannelClass(channel) {
      if (channel === '锦江') return 'channel-jj'
      if (channel === '亚朵') return 'channel-yd'
      if (channel === '龙腾') return 'channel-lt'
      return 'channel-other'
    },

    searchClient(q) {
      if (q === '') {
        this.clientOpts = this.clientMaster
        return
      }
      this.clientLoading = true
      setTimeout(() => {
        this.clientOpts = this.clientMaster.filter(
          (c) => String(c || '').indexOf(q) >= 0,
        )
        this.clientLoading = false
      }, 180)
    },

    formatNumber(val) {
      return parseFloat(val || 0).toLocaleString('zh-CN')
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-hot-hotel {
  .mb18 {
    margin-bottom: 18px;
  }

  .filter-container {
    background: #fff;
    border-radius: 6px;
    // padding: 16px 20px;
    // margin-bottom: 18px;
  }

  .bottom-strip {
    background: #fff;
    border-radius: 6px;
    padding: 20px 24px;
    display: flex;
  }
  .bk-item {
    flex: 1;
    text-align: center;
    position: relative;
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      right: 0;
      top: 10%;
      height: 80%;
      width: 1px;
      background: #ebeef5;
    }
  }
  .bk-label {
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
  }
  .bk-val {
    font-size: 22px;
    font-weight: 700;
  }
  .bk-sub {
    font-size: 11px;
    color: #b4b8bd;
    margin-top: 4px;
  }

  .cust-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .cust-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .cust-count {
    color: #909399;
    font-size: 13px;
    b {
      color: #303133;
    }
  }
  .cust-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .rank-medal {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  }
  .rank-1 {
    background: linear-gradient(135deg, #ffd24d, #f5a623);
  }
  .rank-2 {
    background: linear-gradient(135deg, #edf0f3, #b7bdc4);
  }
  .rank-3 {
    background: linear-gradient(135deg, #e9a87c, #c9824e);
  }
  .rank-num {
    color: #909399;
    font-weight: 600;
    font-size: 13px;
  }

  .hero-rate {
    &.up {
      color: #f56c6c;
    }
    &.down {
      color: #67c23a;
    }
  }

  // 品牌标签
  .brand-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 600;
    &.brand-yd {
      color: #9b59b6;
      background: #f5eefb;
    }
    &.brand-default {
      color: #409eff;
      background: #ecf5ff;
    }
  }

  // 渠道标签
  .channel-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 11px;
    font-size: 12px;
    font-weight: 600;
    &.channel-jj {
      color: #409eff;
      background: #ecf5ff;
    }
    &.channel-yd {
      color: #9b59b6;
      background: #f5eefb;
    }
    &.channel-lt {
      color: #e6a23c;
      background: #fdf6ec;
    }
    &.channel-other {
      color: #909399;
      background: #f4f4f5;
    }
  }

  // 城市标签
  .city-tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 11px;
    font-size: 12px;
    color: #5a7fb5;
    background: #eef3fb;
  }
}
</style>
